var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.725 15.6248H9.05L6.225 18.4498C5.84167 18.8331 5.37067 19.0248 4.812 19.0248C4.25333 19.0248 3.78267 18.8331 3.4 18.4498L0.575 15.6248C0.191667 15.2415 0 14.7665 0 14.1998C0 13.6331 0.191667 13.1581 0.575 12.7748L3.375 9.97481V4.29981L14.725 15.6248ZM4.225 2.37481C6.00833 1.24147 7.93767 0.787141 10.013 1.01181C12.0883 1.23647 13.8757 2.09914 15.375 3.59981C16.875 5.09981 17.7377 6.88747 17.963 8.96281C18.1883 11.0381 17.734 12.9671 16.6 14.7498L15.15 13.2998C15.9 11.9331 16.1627 10.4871 15.938 8.96181C15.7133 7.43647 15.0507 6.12447 13.95 5.02581C12.85 3.92581 11.5373 3.26314 10.012 3.03781C8.48667 2.81247 7.041 3.07514 5.675 3.82581L4.225 2.37481ZM7.175 5.32481C8.125 5.04147 9.08333 4.98314 10.05 5.14981C11.0167 5.31647 11.85 5.74981 12.55 6.44981C13.25 7.14981 13.6793 7.97914 13.838 8.93781C13.9967 9.89647 13.934 10.8505 13.65 11.7998L11.95 10.0998C11.95 9.68314 11.8877 9.27914 11.763 8.88781C11.6383 8.49647 11.434 8.15881 11.15 7.87481C10.85 7.57481 10.504 7.35814 10.112 7.22481C9.72 7.09148 9.30767 7.02481 8.875 7.02481L7.175 5.32481Z",
    fill: "#525252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceIcon);
export default __webpack_public_path__ + "static/media/voiceIcon.10ab0d5a3ee653c9193ba2c21fe3d330.svg";
export { ForwardRef as ReactComponent };